{
  "notifications": {
    "overline": "AJUSTES",
    "title": "Notificaciones",
    "titleHighlight": "Notificaciones",
    "signInHint": "Inicia sesión para gestionar tus preferencias de notificación.",
    "loading": "Cargando ajustes...",
    "loadError": "No se pudieron cargar los ajustes de notificaciones.",
    "retry": "Reintentar",
    "errorTitle": "Algo salió mal",
    "desktop": "Notificaciones de Escritorio",
    "desktopHint": "Recibe notificaciones push para recordatorios de eventos y mensajes",
    "blockedInBrowser": "BLOQUEADAS EN EL NAVEGADOR",
    "blockedHint": "Las notificaciones están bloqueadas. Abre la configuración de tu navegador para permitir notificaciones de este sitio.",
    "push": "Notificaciones push",
    "pushHint": "Recibe avisos de mensajes y recordatorios en este dispositivo",
    "pushBlockedHint": "Las notificaciones están desactivadas. Actívalas en los ajustes del dispositivo.",
    "blockedInSystem": "DESACTIVADAS EN AJUSTES",
    "notificationsOn": "NOTIFICACIONES ACTIVADAS",
    "enableNotifications": "ACTIVAR NOTIFICACIONES",
    "reminderTime": "Hora del Recordatorio",
    "reminderTimeHint": "¿Con cuánta anticipación debemos notificarte antes de que comience una sesión en vivo?",
    "autoNotify": "Auto-Notificar Suscripciones",
    "autoNotifyHint": "Crear recordatorios automáticamente para próximos eventos de maestros que sigues.",
    "autoNotifyOn": "AUTO-NOTIFICAR ACTIVADO",
    "autoNotifyOff": "AUTO-NOTIFICAR DESACTIVADO",
    "footerNote": "Estos ajustes se aplican a las notificaciones push del navegador. Asegúrate de tener las notificaciones habilitadas en tu navegador.",
    "offset30min": "30 min",
    "offset1hour": "1 hora",
    "offset1_5hours": "1.5 horas",
    "offset2hours": "2 horas",
    "catSectionTitle": "Notificaciones",
    "catSectionHint": "Elige de qué quieres enterarte. Todo está activado por defecto.",
    "catMessages": "Mensajes",
    "catMessagesHint": "Notificaciones de mensajes nuevos de amigos y usuarios de la plataforma.",
    "catMasterEvents": "Nuevos eventos de maestros",
    "catMasterEventsHint": "Notificaciones cuando los maestros a los que sigues crean nuevos eventos en línea y presenciales.",
    "catPracticeStart": "Inicio de práctica",
    "catPracticeStartHint": "Notificaciones cuando un maestro al que sigues comienza una práctica o sesión en vivo.",
    "catNewMedia": "Nuevos medios y prácticas",
    "catNewMediaHint": "Notificaciones cuando un maestro publica contenido nuevo.",
    "catSystem": "Notificaciones del sistema",
    "catSystemHint": "Avisos importantes sobre la plataforma, actualizaciones y cambios.",
    "catPostEngagement": "Comentarios y reacciones",
    "catPostEngagementHint": "Cuando comentan o reaccionan a tus publicaciones.",
    "subscriptions": "SUSCRIPCIONES",
    "unavailable": "La configuración no está disponible",
    "nativeFooter": "Los recordatorios llegan como notificaciones sobre tus eventos y las sesiones de tus maestros.",
    "catAgapellaProactive": "Agapella escribe primero",
    "catAgapellaProactiveHint": "Saludos de regreso y recordatorios del compañero de IA. Desactívalo y Agapella no iniciará la conversación, pero seguirá disponible cuando escribas. No afecta a las notificaciones de la plataforma. El resumen semanal tiene su propio interruptor.",
    "catAgapellaWeeklySummary": "Resumen semanal",
    "catAgapellaWeeklySummaryHint": "Una vez por semana Agapella te escribe en su chat un breve resumen: tus prácticas, los minutos y lo que escribiste sobre ti. Las entradas ocultas para la IA nunca se usan. Funciona si aceptaste el tratamiento de datos en el chat de IA."
  },
  "masterProfile": {
    "badge": {
      "required": "Obligatorio",
      "optional": "Opcional"
    },
    "hints": {
      "name": "El nombre que verán los usuarios en tu perfil.",
      "experience": "¿Cuánto tiempo llevas practicando tu dirección elegida? Indica los años y las áreas clave de trabajo.",
      "education": "Estudios, cursos, certificados y escuelas — todo lo que influyó en tu camino profesional.",
      "uniqueness": "¿En qué se diferencia tu enfoque del de otros especialistas? ¿Qué te hace único para los clientes?",
      "philosophy": "¿Qué valores sustentan tu trabajo? Describe tu misión y visión del mundo."
    },
    "about": {
      "title": "Sobre el maestro",
      "name": "Nombre",
      "namePlaceholder": "Tu nombre",
      "directions": "Direcciones / prácticas",
      "experience": "Experiencia en prácticas",
      "experiencePlaceholder": "¿Cuánto tiempo llevas practicando tu dirección elegida?",
      "education": "Educación / certificación",
      "educationPlaceholder": "Estudios, cursos, certificados, escuelas.",
      "uniqueness": "Singularidad del enfoque / metodología",
      "uniquenessPlaceholder": "¿Cómo se diferencia tu enfoque del de otros especialistas?",
      "philosophy": "Filosofía / descripción libre",
      "philosophyPlaceholder": "¿Qué valores sustentan tu trabajo?",
      "philosophyLabel": "Filosofía",
      "showMore": "Mostrar más",
      "aboutMeTitle": "Sobre mí",
      "directionsTitle": "Mis direcciones",
      "directionsEmpty": "No hay direcciones aún."
    },
    "manifesto": {
      "title": "Tarjeta de presentación en video",
      "description": "Sube un video manifiesto que se mostrará en tu perfil.",
      "emptyTitle": "Aún no hay tarjeta de video",
      "emptyHint": "Añádela en los ajustes: es lo primero que ven los visitantes.",
      "uploaded": "Video subido",
      "replace": "Reemplazar",
      "upload": "Subir video",
      "uploadHint": "MP4, hasta 500 MB",
      "cover": "Portada",
      "captureFrame": "Usar fotograma actual",
      "captureHint": "Pausa el video en el momento adecuado y elige el fotograma actual como portada.",
      "captureHintNoVideo": "Primero sube el video, luego elige un fotograma como portada.",
      "uploading": "Subiendo…",
      "uploadingPercent": "Subiendo {{percent}}%",
      "save": "Guardar tarjeta de video",
      "webOnly": "La carga de video está disponible en la versión web.",
      "playbackError": "Todavía no podemos mostrar el video aquí. Ábrelo en una pestaña nueva.",
      "openInNewTab": "Abrir en una pestaña nueva"
    },
    "path": {
      "title": "Mi camino",
      "addStep": "Agregar etapa",
      "description": "Cuéntanos sobre tu camino profesional y personal.",
      "datePlaceholder": "2023-05",
      "eventPlaceholder": "Qué sucedió",
      "deleteStep": "Eliminar etapa del camino"
    },
    "agape": {
      "title": "Lo que Agape significa para mí",
      "upload": "Subir video",
      "description": "Una respuesta en video: ¿qué significa Agape para mí y cómo entiendo la filosofía Agape?",
      "uploaded": "Video subido",
      "replace": "Reemplazar",
      "delete": "Eliminar",
      "uploading": "Subiendo…",
      "uploadingPercent": "Subiendo {{percent}}%",
      "save": "Guardar video",
      "webOnly": "La carga de video está disponible en la versión web."
    },
    "actions": {
      "cancel": "Cancelar",
      "saveChanges": "Guardar cambios",
      "savedOk": "Todos los cambios guardados",
      "pathValidationError": "Completa la fecha (AAAA-MM) y la descripción para todas las etapas del camino",
      "requiredFieldsError": "Completa los campos obligatorios: tu nombre, al menos una dirección y al menos un campo de «Sobre mí»."
    },
    "completion": {
      "title": "Completitud del perfil",
      "sections": {
        "photo": "Foto de perfil",
        "about": "Sobre el maestro",
        "manifesto": "Videopresentación",
        "directions": "Direcciones",
        "socials": "Redes sociales",
        "path": "Mi camino",
        "agape": "Qué significa Agape para mí"
      },
      "addSocials": "Agregar redes sociales →",
      "calculating": "Calculando…",
      "motivationDone": "Perfil completo",
      "motivationAlmost": "¡Casi listo!",
      "motivationGood": "¡Buen progreso!",
      "motivationStart": "¡Buen comienzo!",
      "motivationEmpty": "Completa tu perfil"
    },
    "required": {
      "title": "Secciones obligatorias",
      "subtitle": "Completa todas las secciones obligatorias para publicar tu perfil.",
      "aboutTitle": "Sobre el maestro",
      "fieldsCount": "{{filled}}/{{total}} campos completados",
      "manifestoTitle": "Tarjeta de presentación en video",
      "manifestoAdded": "Video agregado",
      "manifestoMissing": "Sube tu tarjeta de video",
      "directionsTitle": "Direcciones",
      "directionsSelected_one": "{{count}} dirección seleccionada",
      "directionsSelected_other": "{{count}} direcciones seleccionadas",
      "directionsMissing": "Agrega al menos 1 dirección"
    },
    "legend": {
      "title": "Leyenda",
      "filled": "Sección completa",
      "partial": "Sección parcialmente completa",
      "empty": "Sección no completada",
      "optional": "Sección opcional",
      "hintTitle": "Consejo",
      "hintText": "Haz clic en el icono junto al campo para ver ejemplos y recomendaciones de llenado."
    },
    "socials": {
      "title": "Redes sociales y recursos",
      "settingsTitle": "Contactos y redes",
      "filled": "{{filled}} de {{total}} completados",
      "loading": "Cargando enlaces…",
      "active": "Activo",
      "needsFix": "Revisa",
      "edit": "Editar",
      "add": "+ Añadir",
      "save": "Guardar",
      "errors": {
        "notAUrl": "Introduce un enlace válido de {{platform}}",
        "notAUrlWebsite": "Introduce una dirección de sitio web válida",
        "wrongPlatform": "El enlace debe llevar a {{platform}}",
        "placeholderHost": "Esa es una dirección de ejemplo: escribe la tuya",
        "serviceRoot": "Introduce la dirección del perfil, no la página principal de {{platform}}",
        "tooLong": "El enlace es demasiado largo"
      },
      "saveError": "El enlace no se guardó. Inténtalo de nuevo.",
      "willSave": "Se guardará como {{url}}",
      "willClear": "Campo vacío: el enlace se eliminará",
      "platforms": {
        "website": "Sitio web",
        "instagram": "Instagram",
        "youtube": "YouTube",
        "telegram": "Telegram",
        "rutube": "RuTube",
        "dzen": "Dzen",
        "vk": "VK"
      }
    },
    "account": {
      "title": "Cuenta",
      "notifications": "Push y recordatorios",
      "notificationsDesc": "Permiso del navegador y antelación de los recordatorios",
      "library": "Favoritos",
      "libraryDesc": "Prácticas y materiales favoritos",
      "theme": "Tema",
      "themeDesc": "Apariencia de la interfaz",
      "themeDark": "Oscuro",
      "themeLight": "Claro",
      "themeSystem": "Sistema",
      "security": "Seguridad de inicio de sesión",
      "securityDesc": "Passkey y contraseña",
      "logout": "Cerrar sesión"
    },
    "editors": {
      "section": "PERFIL DEL MAESTRO",
      "profile": "Configuración del perfil",
      "profileHint": "Foto, portada, nombre, ciudad",
      "aboutHint": "Experiencia, formación, filosofía",
      "directionsHint": "A qué te dedicas",
      "pathHint": "Etapas y eventos",
      "done": "Listo",
      "hintA11y": "Pista para el campo «{{label}}»",
      "cover": "Portada",
      "photo": "Foto de perfil",
      "location": "Ciudad / país",
      "locationPlaceholder": "Por ejemplo, Madrid",
      "directionsNote": "Elige las direcciones en las que trabajas.",
      "pathNote": "Etapas del camino: fecha (AAAA-MM) y descripción.",
      "dateFormat": "AAAA-MM",
      "saveFailed": "No se pudo guardar",
      "socialsNote": "Enlaces a tus perfiles: aparecerán en tu perfil público de maestro.",
      "aboutEmpty": "El perfil aún no está completo: añade una descripción en la configuración."
    },
    "visibility": {
      "title": "Visibilidad del perfil",
      "visible": "Tu perfil es visible",
      "visibleDesc": "Te encuentran en el catálogo de maestros, por enlace directo y en las recomendaciones de Agapella.",
      "hiddenByOwner": "Perfil oculto",
      "hiddenByOwnerDesc": "Los demás no ven tu perfil en el catálogo ni por enlace directo. Puedes seguir editándolo: los cambios no lo harán público sin tu decisión.",
      "hiddenByAdmin": "Oculto por la plataforma",
      "hiddenByAdminDesc": "No puedes restaurarlo desde aquí; solo el equipo de Agapella puede hacerlo.",
      "notPublished": "Perfil no publicado",
      "notPublishedDesc": "Ahora no hay una versión pública de tu perfil, así que no hay nada que ocultar.",
      "keeps": "Ocultar no elimina tu cuenta. Las prácticas, grabaciones, sesiones Live, suscripciones, compras y chats se conservan, y las conversaciones iniciadas siguen funcionando.",
      "hide": "Ocultar perfil",
      "unhide": "Volver a mostrar",
      "confirmTitle": "¿Ocultar tu perfil?",
      "confirmBody": "Tu perfil, prácticas y sesiones Live dejarán de mostrarse a otras personas. Puedes volver a hacerlo visible aquí en cualquier momento.",
      "confirm": "Ocultar",
      "cancel": "Cancelar",
      "errors": {
        "nothingToHide": "Aún no hay nada que ocultar: tu perfil no tiene versión publicada.",
        "hiddenByAdmin": "La plataforma ocultó tu perfil y no se puede restaurar desde aquí.",
        "noProfile": "No se encontró el perfil de maestro.",
        "generic": "No se pudo guardar. Revisa la conexión e inténtalo de nuevo."
      },
      "bannerOwner": "Tu perfil está oculto: no aparece en el catálogo ni por enlace.",
      "bannerAdmin": "La plataforma ocultó tu perfil y no es visible para otras personas.",
      "bannerAction": "Ajustes de visibilidad"
    }
  },
  "app": {
    "title": "Configuración",
    "language": {
      "title": "Idioma",
      "hint": "Idioma de la interfaz de la app"
    },
    "account": {
      "section": "CUENTA",
      "email": "EMAIL",
      "notifications": "Notificaciones",
      "notificationsHint": "Push y recordatorios de eventos",
      "socials": "Redes sociales",
      "socialsHint": "Enlaces a tus perfiles",
      "library": "Mi biblioteca",
      "libraryHint": "Prácticas guardadas y listas de reproducción"
    },
    "privacy": {
      "section": "PRIVACIDAD",
      "calendar": "Calendario de eventos",
      "calendarHint": "Quién ve a qué eventos vas",
      "feed": "Prácticas en el feed",
      "feedHint": "Quién ve las prácticas que añades al feed",
      "all": "Todos",
      "subscribers": "Suscriptores",
      "onlyMe": "Solo yo"
    },
    "assistant": {
      "section": "AGAPELLA",
      "proactive": "Mensajes proactivos",
      "proactiveHint": "Con qué frecuencia Agapella escribe primero",
      "normal": "Normal",
      "reduced": "Menos",
      "off": "Nunca",
      "aiData": "Datos e IA",
      "consentGranted": "Consentimiento para compartir mensajes con el servicio de IA otorgado",
      "consentMissing": "Sin consentimiento — el chat con la asistente de IA está cerrado",
      "eraseTitle": "¿Eliminar tus datos del chat con IA?",
      "eraseBody": "Se eliminarán la memoria a largo plazo, el perfil creado a partir de ella y la propia conversación: lo que contaste sobre ti tendrás que contarlo de nuevo. Esto no se puede deshacer.",
      "eraseCancel": "Cancelar",
      "eraseConfirm": "Eliminar",
      "eraseDoneTitle": "Listo",
      "eraseDoneBody": "La memoria, el perfil y tu conversación con la asistente se han eliminado.",
      "erasePartialTitle": "No se eliminó todo",
      "erasePartialBody": "Se ha eliminado lo que se guarda en el servidor principal. La conversación, la memoria a largo plazo de la asistente y el perfil que creó están en el servicio de chat, que ahora no está disponible, así que no se pudieron eliminar. Inténtalo de nuevo más tarde.",
      "eraseFailTitle": "No se pudo",
      "eraseFailBody": "No se pudieron eliminar los datos. Revisa la conexión e inténtalo de nuevo, o escribe a info@agapella.io.",
      "revokeTitle": "¿Retirar el consentimiento?",
      "revokeBody": "El chat con la asistente de IA se cerrará y todo lo ya recopilado se eliminará: la memoria a largo plazo, el perfil creado a partir de ella y la conversación. Esto no se puede deshacer.",
      "revokeConfirm": "Retirar y eliminar",
      "memoryChatNote": "Estas son las notas que la asistente ha guardado sobre ti. Esta pantalla aún no muestra la memoria a largo plazo de tus conversaciones; puedes eliminarla por completo en Ajustes, en «Datos e IA»."
    },
    "security": {
      "section": "CUENTA Y SEGURIDAD",
      "blocked": "Lista de bloqueados",
      "blockedNone": "Nadie está bloqueado",
      "blockedCount_one": "{{count}} persona",
      "blockedCount_many": "{{count}} personas",
      "blockedCount_other": "{{count}} personas"
    },
    "legal": {
      "section": "INFORMACIÓN LEGAL",
      "terms": "Términos de uso",
      "termsHint": "Normas de la plataforma y de conducta",
      "privacy": "Política de privacidad",
      "privacyHint": "Cómo tratamos tus datos"
    },
    "marketing": {
      "title": "Mensajes promocionales",
      "grantedHint": "Aceptaste recibir mensajes promocionales. Toca para retirar el consentimiento",
      "deniedHint": "No te enviamos mensajes promocionales. Toca para permitirlos",
      "on": "Permitidos",
      "off": "No permitidos",
      "errorRejected": "Ahora no es posible dar este consentimiento: el servidor no lo aceptó. Si tienes dudas, escribe a soporte.",
      "errorFailed": "No se pudo guardar tu elección. Revisa la conexión e inténtalo de nuevo."
    }
  },
  "securityScreen": {
    "passwordSection": "CONTRASEÑA",
    "changePassword": "Cambiar contraseña",
    "setPassword": "Crear contraseña",
    "changeHint": "Enviaremos un enlace a {{email}} — con él podrás cambiar la contraseña.",
    "setHint": "Enviaremos un enlace a {{email}} — con él podrás crear una contraseña.",
    "yourEmail": "tu correo",
    "sent": "Correo enviado. Revisa {{email}}.",
    "sendFailed": "No se pudo enviar el correo",
    "passkeySection": "DISPOSITIVOS Y PASSKEY",
    "passkeyTitle": "Acceso con passkey",
    "passkeyHint": "El acceso sin contraseña con passkey por ahora está disponible en la versión web. Lo añadiremos al teléfono más adelante."
  }
}
